
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"}},_vm.$listeners),[_c('path',{attrs:{"d":"M8 12a2 2 0 1 1-2 2 2.006 2.006 0 0 1 2-2m0-6a2 2 0 1 1-2 2 2.006 2.006 0 0 1 2-2m0-6a2 2 0 1 1-2 2 2.006 2.006 0 0 1 2-2Z"}})])}
var staticRenderFns = []

    export default {
      render: render,
    }
  